const landing_page = {
  aboutUs: "회사 소개", // translated 
  topPackages: "최고 패키지", // translated 
  featuredHotels: "추천 호텔", // translated 
  topTours: "탑 투어", // translated 
  whatOurMembersSay: "회원들의 의견...", // translated 
  followUsOnInstagram: "인스타그램에서 저희를 팔로우하세요", // translated 
  pleaseWait: "기다리세요...", // translated 
  packages: "패키지", // translated 
  ourPartners: "파트너사", // translated 
  trustedCarHirePartners: "신뢰할 수 있는 렌터카 파트너", // translated 
  learnMore: "더 알아보기", // translated 
};


export default landing_page;
